"use client";
import { Chip, ChipProps } from "@mui/material";
import React, { memo } from "react";

const AppChip = ({ label, sx, ...otherProps }: ChipProps) => {
  return (
    <Chip
      sx={{
        padding: "4px",
        minHeight: "24px",
        gap: "8px",
        height: "unset",
        fontSize: "14px",
        fontWeight: 400,
        borderWidth: "1px",
        borderRadius: "4px",
        "& .MuiChip-label": {
          padding: 0,
        },
        ...sx,
      }}
      label={label}
      variant="outlined"
      {...otherProps}
    />
  );
};

export default memo(AppChip);
